
        <fieldmagic-dialog
            label="Completion Details"
            icon="check-circle"
            [instance]="this"
        >
            <ng-template fieldmagicDialogButtonsTmp>
                <fieldmagic-primary-button
                    [isInProgress]="saving$ | async"
                    purpose="save"
                    (click)="onSave()"
                >
                </fieldmagic-primary-button>
            </ng-template>

            <ng-template fieldmagicDialogContentTmp>
                <div fieldmagicGridRow>
                    <div fieldmagicGridColumn="6">
                        <fieldmagic-calendar-input
                            label="Date Completed"
                            [(ngModel)]="dateCompleted"
                            [clearable]="false"
                            [standalone]="false"
                            type="datetime"
                            [errors]="errors | data_get: 'date_completed'"
                        >
                        </fieldmagic-calendar-input>
                    </div>

                    <div fieldmagicGridColumn="6">
                        <fieldmagic-relate-input
                            label="Completed By"
                            [(ngModel)]="completedBy"
                            moduleName="users"
                            [clearable]="false"
                            [standalone]="false"
                            [errors]="errors | data_get: 'completed_by'"
                        >
                        </fieldmagic-relate-input>
                    </div>
                </div>
            </ng-template>
        </fieldmagic-dialog>
    